import axios from 'axios';
import { constructServiceURL } from '../../../../core/modules/common/tools/URLTools';
import config from '../../../../core/config/configureSettings';
import { getApiPeriod } from '../../period-selector/redux/selectors/PeriodSelectionSelectors';

export const postHandler = ({ stretch, startDate, endDate }) => {
  const serviceURL = constructServiceURL({
    endpoint: 'postHandler',
    stub: config.useStubbedEndpoints,
  });

  const period = getApiPeriod({
    period: { startDate, endDate },
  });

  return axios.post(serviceURL, { stretch, period });
};

export default postHandler;
